export const INFO = 'VIEW_MODE__INFO';
export const EDIT = 'VIEW_MODE__EDIT';
export const TARGET = 'VIEW_MODE__TARGET';
export const AUDIENCE = 'VIEW_MODE__AUDIENCE';
// export const RUN = 'VIEW_MODE__RUN'
